import type { VariationDataSource } from '@g17eco/types/universalTracker';
import { BulkActionUtr } from '../../types/survey-question-list';
import { MetricOverrideType } from './metric-override/types';

export interface QuestionConfigurationModalProps {
  isOpen: boolean;
  initiativeId: string;
  configType: ConfigurationType;
  selectedQuestions: BulkActionUtr[];
  toggleOpen: () => void;
  handleReload: (props?: { reloadSurvey?: boolean; closeModal?: boolean }) => Promise<void | undefined>;
}

export interface QuestionManagementContextProps {
  inputOverrideType: InputOverrideType | undefined;
  setInputOverrideType: (type: InputOverrideType | undefined) => void;
  metricOverrideCode: keyof MetricOverrideType | undefined;
  setMetricOverrideCode: (code: keyof MetricOverrideType | undefined) => void;
}

export type QuestionConfigurationButtonProps = {
  name?: string;
  disabled?: boolean;
  onClick?: () => void;
} & Omit<QuestionConfigurationModalProps, 'isOpen' | 'toggleOpen'>;

export interface MetricOverrideProps {
  handleReload: (props?: { reloadSurvey?: boolean; closeModal?: boolean }) => Promise<void | undefined>;
  selectedQuestions: BulkActionUtr[];
  numericSelectedQuestions: BulkActionUtr[];
  initiativeId: string;
  handleCloseModal: () => void;
  formActionsLeftContent?: React.ReactNode;
}

export enum InputOverrideType {
  Unit = 'unit',
  NumberScale = 'numberScale',
  Decimal = 'decimal',
  Variation = 'variation',
  Mandatory = 'mandatory',
}

export enum ConfigurationType {
  MetricOverrides = 'Metric overrides',
  InputOverrides = 'Input overrides',
  Tags = 'Assign tags',
  AggregationOverrides = 'Aggregation rules',
  ValueList = 'Dropdown options',
}

export enum InputOverrideFormType {
  SingleInput = 'single-input',
  Table = 'table',
}

export type InputOverrideDataType<T = string> = { value: T | undefined; isEnforced: boolean };

export type DecimalType = Record<string, InputOverrideDataType<number>>;

export interface ErrorDecimalType {
  [key: string]: string | undefined;
}

export type UnitConfigValueType = InputOverrideDataType & { isLocked: boolean };

// key can be __DATA__ or column's code
export type UnitConfigType = Record<string, Record<string, UnitConfigValueType>>;

export type VariationInput = InputOverrideDataType<number> & {
  dataSource: VariationDataSource | undefined;
  confirmationRequired: boolean | undefined;
};

// key can be __DATA__ or column's code
export type VariationInputMap = Record<string, VariationInput>;

export type MandatoryInput = {
  isEnforced: boolean;
  isLockedByUtr: boolean;
};

// key is column's code (only for Table questions)
export type MandatoryInputMap = Record<string, MandatoryInput>;

export type UnitTypeMapValue = {
  defaultValue: string | undefined;
  overriddenValue: string | undefined;
  isLocked: boolean;
};
